import { ReactComponent as HistoryIcon } from './history.svg';

export default HistoryIcon;
